import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function getUserActivityList(data){
    return request({
        url:Api.operation.list,
        method:configs.http.request.methodPost,
        data
    })
}

export function exportUserActivityList(data){
    return request({
        url:Api.operation.export,
        method:configs.http.request.methodPost,
        data
    })
}